import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';


@Component({
  selector: 'ds-video-error',
  imports: [TranslatePipe],
  templateUrl: './video-error.component.html',
  styleUrls: ['./video-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoErrorComponent { }
